module.exports = __webpack_public_path__ + "img/credit-card-sprite.2336391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/credit-card-sprite.png
// module id = 1092
// module chunks = 0